module.exports = __webpack_public_path__ + "images/display_hospital_small_pending.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/display_hospital_small_pending.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--1-0!/tool/node_modules/img-loader/index.js??ref--1-1!/tool/project/client/src/site__mhf/images/display_hospital_small_pending.svg
// module chunks = site__mhf